<template>
  <div>
    <CompleteTable
      v-if="!loading"
      :sorted-field="sortedField"
      :data="applicants"
      :sort-mapping="sortMapping"
      :title="'applicants with retrieves'"
      :total="applicantsTotal"
      :fetch-path="'convo/fetchApplicants'"
      :export-path="'lines/export'"
      :filter-path="'-'"
      :actions="true"
      @selectedItems="saveSelectedItems"
      @appliedFilters="appliedFilters"
    >
      <template v-slot="{field}">
        <td
          class="text-end"
        >
          <b-dropdown
            variant="link"
            no-caret
            toggle-class="p-0"
            right
          >
            <template #button-content>
              <i data-feather="more-vertical" />
            </template>
            <div
              class="btn-group dropup dropdown-icon-wrapper d-none d-sm-block"
            >
              <b-dropdown-item @click="changeRetrieve(field, true)">
                <i
                  class="me-50"
                  data-feather="thumbs-up"
                /> Accept retrieve
              </b-dropdown-item>
              <b-dropdown-item @click="changeRetrieve(field, false)">
                <i
                  class="me-50"
                  data-feather="x"
                /> Deny retrieve
              </b-dropdown-item>
              <div class="dropdown-divider" />
              <b-dropdown-item @click="selectedItem = field, $store.dispatch('modals/toggleFormEvaluation', true)">
                <i
                  class="me-50"
                  data-feather="eye"
                /> View form evaluation
              </b-dropdown-item>
              <b-dropdown-item @click="$store.dispatch('modals/toggleFormEvaluation', true)">
                <i
                  class="me-50"
                  data-feather="eye"
                /> View traces
              </b-dropdown-item>
              <div class="dropdown-divider" />
              <b-dropdown-item
                :href="$router.resolve({ name: 'admin.users.edit', params: { id: field.user_id }, query: { actAs: $route.query.actAs } }).href"
                target="_blank"
              >
                <i
                  class="me-50"
                  data-feather="edit"
                />
                Edit profile
              </b-dropdown-item>
            </div>
          </b-dropdown>
          <a
            href=""
            class="btn btn-icon btn-light-secondary d-block d-sm-none"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasMenu"
            aria-controls="offcanvasBottom"
          ><i
            data-feather="more-vertical"
          /></a>
        </td>
      </template>
      <template #customfilters>
        <div class="mb-1">
          <label
            for="nameseniorcall"
            class="form-label"
          >Candidate</label>
          <input
            v-model="filters.candidate"
            type="text"
            class="form-control"
            name="nameseniorcall"
            @change="saveFilter({ customLabel: true, name: `Candidate: ${$event.target.value}`, value: $event.target.value }, 'candidate')"
          >
        </div>
        <div class="mb-1">
          <label
            for=""
            class="form-label"
          >Status</label>
          <select
            id=""
            name=""
            class="form-select"
            @change="saveFilter({ customLabel: true, name: `Status: ${getStatusName($event.target.value)}`, value: $event.target.value !== '0' ? $event.target.value : null }, 'status')"
          >
            <option value="0">
              All applicants
            </option>
            <option value="3">
              Not eligible
            </option>
            <option value="4">
              1st round
            </option>
            <option value="5">
              2nd round
            </option>
            <option value="6">
              Ranked
            </option>
            <option value="7">
              Offered
            </option>
            <option value="8">
              Position accepted
            </option>
          </select>
        </div>
        <div class="mb-1">
          <div class="row">
            <div class="col-6">
              <label
                for="nameseniorcall"
                class="form-label"
              >AVG Grade min.</label>
              <input
                v-model="filters.avg_min"
                type="number"
                step="0.01"
                class="form-control"
                name="nameseniorcall"
                @change="saveFilter({ customLabel: true, name: `AVG Grade min.: ${$event.target.value}`, value: `${$event.target.value}` }, 'avg_min')"
              >
            </div>
            <div class="col-6">
              <label
                for="nameseniorcall"
                class="form-label"
              >AVG Grade max</label>
              <input
                v-model="filters.avg_max"
                type="number"
                step="0.01"
                class="form-control"
                name="nameseniorcall"
                @change="saveFilter({ customLabel: true, name: `AVG Grade max.: ${$event.target.value}`, value: `${$event.target.value}` }, 'avg_max')"
              >
            </div>
          </div>
        </div>
      </template>
      <template #info-sheet-item>
        <div class="offcanvas-body offcanvas-body--view">

          <h4 class="mb-2">
            <strong class="text-success">{{ selectedItems.length }}</strong> selected applicants
          </h4>

          <ul
            v-if="!customActions"
            id="basic-list-group"
            class="list-group"
          >
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction5"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="3"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction5"
                    >Move to Not elegible</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction10"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="2"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction10"
                    >Move to round 0</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction6"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="4"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction6"
                    >Move to round 1</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction7"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="5"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction7"
                    >Move to round 2</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction8"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="6"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction8"
                    >Move to ranked</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction1"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="8"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction1"
                    >Move to accepted</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction1"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="9"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction1"
                    >Move to blocked for next year</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction1"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="10"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction1"
                    >Move to rejected</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction1"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="11"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction1"
                    >Move to renounced</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction1"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="13"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction1"
                    >Move to declined</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction1"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="14"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction1"
                    >Move to diseased</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction1"
                      v-model="actions.moveRound"
                      type="radio"
                      class="form-check-input"
                      name="actions"
                      value="7"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction1"
                    >Move to offered</label>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="offcanvas-footer mt-auto">
          <a
            href="#"
            title="apply actions"
            class="btn btn-primary mb-1 d-grid w-100"
            @click="applyActions"
          >Apply actions</a>
        </div>
      </template>
    </CompleteTable>
    <ShowFormEvaluation :selected="selectedItem" />
    <div
      v-if="loading"
      id="loading-bg"
    >
      <div
        class="loading"
      >
        <div class="effect-1 effects" />
        <div class="effect-2 effects" />
        <div class="effect-3 effects" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CompleteTable from '@/views/back/partials/components/CompleteTable.vue'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import Vue from 'vue'
import ShowFormEvaluation from './ShowFormEvaluation.vue'

export default {
  components: {
    CompleteTable,
    BDropdown,
    BDropdownItem,
    ShowFormEvaluation,
  },
  props: {
    status: { type: Number, required: false, default: () => null },
    round: { type: Number, required: false, default: () => 1 },
  },
  data() {
    return {
      sortedField: 'Name',
      defaultFields: [
        {
          name: 'Name',
          checked: true,
          order: 1,
        },
        {
          name: 'Area',
          checked: true,
          order: 2,
        },
        {
          name: 'ERC',
          checked: true,
          order: 3,
        },
        {
          name: 'Institution',
          checked: true,
          order: 4,
        },
        {
          name: 'Author',
          checked: true,
          order: 5,
        },
        {
          name: 'Evaluators',
          checked: true,
          order: 6,
        },
        {
          name: 'Reason',
          checked: true,
          order: 7,
        },
        {
          name: 'Traces',
          checked: true,
          order: 8,
        },
        {
          name: 'Decision',
          checked: true,
          order: 9,
        },
        {
          name: 'Status',
          checked: true,
          order: 10,
        },
      ],
      sortMapping: {
        Name: 'full_name',
        Area: 'area',
        ERC: 'erc',
        Institution: 'institution_name',
        Evaluators: 'evaluators',
        Reason: 'retrieve.reason',
        Traces: 'traces.length',
        Decision: 'retrieve.answer',
        Author: 'retrieve.evaluator.name',
        Status: 'status.status_table',
      },
      actions: {
        moveRound: null,
      },
      selectedItems: [],
      selectedItem: {},
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      convo: 'convo/convo',
      applicants: 'convo/applicants',
      applicantsTotal: 'convo/applicantsTotal',
      fields: 'modals/tableSettingsFields',
      filters: 'filters/filters',
    }),
  },
  async mounted() {
    this.$store.dispatch('modals/fetchUserFields', 'retrieves_table')
    await this.$store.dispatch('convo/fetchApplicants', {
      id: this.$route.params.id, retrieve_round: this.round, status: { value: 997 }, ...this.filters,
    })
    this.loading = false

    if (!this.fields || this.fields.length === undefined) { // If user doesnt have default fields, load the true default
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'retrieves_table',
      })
    }
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    async appliedFilters() {
      this.loading = true
      await this.$store.dispatch('convo/fetchApplicants', {
        id: this.$route.params.id, retrieve_round: this.round, status: { value: 997 }, ...this.filters,
      })
      this.loading = false
    },
    async changeRetrieve(applicant, answer) {
      this.$toastr.info('', 'Changing status...')
      this.loading = true
      await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/convo/update/update-retrieve`, {
        retrieve_id: applicant.retrieve.id,
        answer,
      })

      await this.$store.dispatch('convo/fetchApplicants', {
        id: this.$route.params.id, retrieve_round: this.round, status: { value: 997 }, ...this.filters,
      })
      this.loading = false

      this.$toastr.success('', 'Retrieve status successfully changed!')
    },
    applyActions() {
      if (this.selectedItems.length > 0) {
        Vue.swal({
          title: 'Perform actions on the selected applicants?',
          html: '',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Yes',
        }).then(result => {
          if (result.isConfirmed) {
            const itemIds = this.selectedItems.map(el => el.user_id)
            this.$store.dispatch('users/changeStatus', { actions: this.actions, itemIds, convoId: this.convo.id }).then(() => {
              this.$store.dispatch('convo/fetchApplicants', {
                id: this.$route.params.id, retrieve_round: this.round, status: { value: 997 }, ...this.filters,
              })
              this.$store.dispatch('modals/toggleInfoItemSheet', false)
              this.$toastr.success('', 'Actions applied successfully')
            })
          }
        })
      } else {
        this.$toastr.error('', 'No items selected!')
      }
    },
    saveSelectedItems(items) {
      this.selectedItems = items
    },
    saveFilter(value, field) {
      if (!value || (!value.value || (value.value === 'null' || (Array.isArray(value.value) && !value.value.length)))) {
        this.$store.dispatch('filters/deleteFilters', field)
      } else {
        this.$store.dispatch('filters/saveFilters', {
          value,
          field,
        })
      }
    },
    getStatusName(value) {
      let str = ''
      switch (value) {
        case '0':
          str = 'All applicants'
          break
        case '3':
          str = 'Not elegible'
          break
        case '4':
          str = '1st round'
          break
        case '5':
          str = '2nd round'
          break
        case '6':
          str = 'Ranked'
          break
        case '7':
          str = 'Offered'
          break
        case '8':
          str = 'Position accepted'
          break
        default:
          break
      }
      return str
    },
  },
}
</script>
